export default __webpack_public_path__ + "static/habersham-2da86e5130e345dae888abdf522c56f8.jpg";